<template>
  <div class="ship-promo-guide">
    <svg
      class="ship-promo-guide__icon"
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M1 5h13v11H1zM14 9h4l4 4v3h-8z" />
      <circle cx="6" cy="18" r="2" />
      <circle cx="18" cy="18" r="2" />
    </svg>
    <div>
      Spend $85, <strong>ship FREE</strong>.
      <div class="ship-promo-guide__note">
        Just enter <b>FreeUp</b> at checkout
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.ship-promo-guide {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #fff;
  color: #222;
  font-size: 13px;
  line-height: 18px;
  &__icon {
    flex: none;
    margin-top: 2px;
    color: #c4571a;
  }
  &__note {
    margin-top: 2px;
  }
  b {
    color: #c4571a;
  }
}
</style>
